import { render } from "./ticket-submission.vue?vue&type=template&id=f49d4d8e&ts=true"
import script from "./ticket-submission.vue?vue&type=script&lang=ts"
export * from "./ticket-submission.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__